import ApiError from "../../errors/ApiError";
import { LINK_CUSTOMER_KROSS_ERROR } from "./error-codes.constants";

export class LinkCustomerKrossError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_KROSS_ERROR);
  }
}
